import clsx from 'clsx';

export const FieldWrapper = (props) => {
  const { label, className, error, children } = props;
  return (
    <div className="">
      <div
        className={clsx(`block text-sm font-medium text-gray-700 dark:text-gray-200`, className)}
      >
        <div className="ml-3">{label}</div>
        <div className="mt-1">{children}</div>
      </div>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className="mx-2 mt-1 text-sm font-semibold text-red-500"
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
